import { gql } from '@apollo/client';

const REFRESH_LOGIN_MUTATION = gql`
  mutation useRefreshTokenToLogin($refreshToken: String!) {
    loginResult: useRefreshTokenToLogin(input: { refreshToken: $refreshToken }) {
      result {
        accessToken
        refreshToken
      }
    }
  }
`;

export default REFRESH_LOGIN_MUTATION;
